<div class="new-card primary declined status-card">
  <div class="info-wrapper">
    <img src="/assets/images/ocd/cl-rejected.png" />
    <h2 class="status-header">We are not able to approve your application this time</h2>
  </div>
  <div class="reason">
    <h3>What is the reason?</h3>
    <ng-container *ngIf="declinedReason">
      <p [innerHTML]="declinedReason"></p>
    </ng-container>
    <ng-container *ngIf="!declinedReason">
      <p>
        It could be due to one of the following:
      </p>
      <ul>
        <li>You don't have regular income or you are a student</li>
        <li>You have a poor credit score</li>
        <li>Mismatch in data provided</li>
      </ul>
    </ng-container>
    <p class="footer-note">
      Don't think any of these reasons apply to you? Please email us at <a
        href="mailto:help@zestmoney.in">help@zestmoney.in</a>
    </p>
  </div>
</div>